module.exports = __webpack_public_path__ + "static/media/Vita noAward.21242d48.svg";